<!--
 * @Author: wh
 * @Date: 2020-07-28 20:24:40
 * @LastEditTime: 2021-07-01 18:24:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JT_Web_test\src\views\purchaseManage\materialMakeup\dayMakeup.vue
-->
<template>
    <div class="monthMakeup">
        <div class="table-con">
            <table class="custom-table">
                <thead>
                    <tr>
                        <th class="column-tit" style="width:100px">
                            企业名称：
                        </th>
                        <th>
                            {{ formData.enterprise_name }}
                        </th>
                        <th class="column-tit" style="width:100px">
                            场站：
                        </th>
                        <th>
                            <el-select
                                v-model="formData.station_name"
                                placeholder="请选择"
                                @change="supplySiteChange"
                            >
                                <el-option
                                    v-for="k in supplySites"
                                    :key="k.station_id"
                                    :label="k.station_name"
                                    :value="k.station_name"
                                >
                                </el-option>
                            </el-select>
                        </th>
                    </tr>
                    <tr>
                        <th class="column-tit">
                            合同编号：
                        </th>
                        <th>
                            {{ formData.contract_number }}
                        </th>
                        <th class="column-tit" style="width: 120px">
                            供应商名称：
                        </th>
                        <th>
                            {{ formData.supplier_name }}
                        </th>
                    </tr>
                    <tr>
                        <th class="column-tit">
                            合同名称：
                        </th>
                        <th>
                            {{ formData.contract_name }}
                        </th>
                        <th class="column-tit">
                        </th>
                        <th>
                        </th>
                    </tr>
                    <tr>
                        <th class="column-tit">
                            补录日期：
                        </th>
                        <th>
                            <el-date-picker
                                type="date"
                                v-model="formData.supplement_date"
                                placeholder="请选择"
                                value-format="yyyy-MM-dd"
                                @change="choseDate"
                            >
                            </el-date-picker>
                        </th>
                        <th class="column-tit">
                            录入人：
                        </th>
                        <th>
                            {{ formData.creator }}
                        </th>
                    </tr>
                    <tr>
                        <th colspan="2">
                            补录每日原材料采购数据情况如下：
                        </th>
                        <th colspan="2">
                            单位：吨，元
                        </th>
                    </tr>
                </thead>
            </table>
            <el-table
                :data="tableData"
                style="width: 100%"
                height="calc(100% - 220px)"
            >
                <el-table-column
                    prop="type_name"
                    label="原材料名称"
                    fixed
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.type_name">{{ scope.row.type_name }}</span>
                        <el-input
                            v-model="scope.row.type_name"
                            placeholder="请选择"
                            @focus="choseRow(scope.$index)"
                            v-else
                        >
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="child_type_name"
                    label="原材料子类"
                    fixed
                >
                </el-table-column>
                <el-table-column
                    prop="spec_name"
                    label="原材料规格"
                    fixed
                >
                </el-table-column>
                <el-table-column
                    prop="source_name"
                    label="货源地"
                    fixed
                >
                </el-table-column>
                <el-table-column label="本日采购">
                    <el-table-column
                        label="采购量"
                    >
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.purchase_volume"
                                @blur="computedVolume(scope.row)"
                                v-if="scope.$index<tableData.length-1"
                            ></el-input>
                            <span v-else>{{ scope.row.purchase_volume }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="采购单价(不含税)"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.unit_price }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="采购单价(含税)"
                    >
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.unit_price_tax"
                                v-if="scope.$index<tableData.length-1"
                                @blur="computedVolume(scope.row)"
                            ></el-input>
                            <span v-else></span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="税率（%）"
                    >
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.tax_rate"
                                v-if="scope.$index<tableData.length-1"
                                @blur="computedVolume(scope.row)"
                            ></el-input>
                            <span v-else></span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="采购金额(不含税)"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.amount }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="税额"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tax_amount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="采购金额(含税)"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.amount_tax }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作列"
                    >
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                class="danger"
                                @click="handleDelete(scope.$index, scope.row)"
                                v-if="scope.$index<tableData.length-1"
                            >
                                删除
                            </el-button>
                            <el-button
                                type="text"
                                v-else
                                @click="addRow"
                            >
                                新增一行
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="btn-con">
            <button class="save" @click="handleSave">
                保存
            </button>
            <button class="Close" @click="handleColse">
                关闭
            </button>
        </div>
    </div>
</template>

<script>
import store from '@/store';
export default {
    components: {},
    props: {
        extr: {
            type: Object,
        },
    },
    data() {
        return {
            formData: {},
            tableData: [],
            sumRow: {
                type_name: '合计',
                child_type_name: '',
                spec_name: '',
                source_name: '',
                purchase_volume: '',
                unit_price: '',
                unit_price_tax: '',
                tax_amount: '',
                tax_rate: '',
                amount: '',
                amount_tax: '',
            },
            // 合同编号
            contract_number: '',
            // 场站
            supplySites: [],
            // 场站id
            station_id: '',
            // 补录月份
            supplementTime: '',
            // 选中index
            selectedIndex: 0,
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.initData();
    },
    methods: {
        // 关闭
        handleColse() {
            this.$parent.hide();
        },
        // 保存
        async handleSave() {
            if (this.tableData.length > 0) {
                const sumRow = this.tableData[this.tableData.length - 1];
                this.formData.month_purchase_volume_total = sumRow.purchase_volume;
                this.formData.tax_amount_total = sumRow.tax_amount;
                this.formData.amount_total = sumRow.amount;
                this.formData.amount_tax_total = sumRow.amount_tax;
                const tableData = JSON.parse(JSON.stringify(this.tableData));
                tableData.pop();
                this.formData.PSDOutputInfo = tableData;
            } else {
                this.formData.PSDOutputInfo = [];
            }
            if (this.extr.handleType === 'new') {
                const res = await this.addSupplementMonthApi(this.formData);
                if (res) {
                    this.$message.success('保存成功');
                    store.state.currentOpenList.forEach(item => {
                        item.tableObj.updateTable();
                    });
                    this.$parent.hide();
                }
            } else {
                const res = await this.modifySupplementDayApi(this.formData);
                if (res) {
                    this.$message.success('修改成功');
                    store.state.currentOpenList.forEach(item => {
                        item.tableObj.updateTable();
                    });
                    this.$parent.hide();
                }
            }

        },
        // 初始化数据
        initData() {
            if (this.extr.QueryString) {
                this.contract_number = this.extr.QueryString.split('=')[1];
            }
            if (this.extr.handleType === 'new') {
                this.getContractMonth();
                this.getSupplySites();
            } else {
                this.getContractMonthByid(this.extr.id);
            }

        },
        // 拉取合同信息
        async getContractMonth() {
            const res = await this.getContractMonthApi();
            if (res) {
                this.formData = res;
                this.formData.creator = this.$takeTokenParameters('Name');
                if (!res.PSDOutputInfo) {
                    res.PSDOutputInfo = [];
                }
                this.tableData = res.PSDOutputInfo;
                this.tableData.map(item => {
                    // 采购单价（不含税）=采购单价（含税）/（1+税率%）
                    if (item.unit_price_tax) {
                        if (item.tax_rate) {
                            item.unit_price = (Number(item.unit_price_tax) / (1 + Number(item.tax_rate) / 100)).toFixed(2);
                        } else {
                            item.unit_price = (Number(item.unit_price_tax) / 1).toFixed(2);
                        }
                    }
                });
                this.sumRow.purchase_volume = this.formData.month_purchase_volume_total;
                this.sumRow.tax_amount = this.formData.tax_amount_total;
                this.sumRow.amount = this.formData.amount_total;
                this.sumRow.amount_tax = this.formData.amount_tax_total;
                if (this.tableData.length > 0) {
                    this.tableData.push(this.sumRow);
                }
            }
        },
        // 根据id拉取
        async getContractMonthByid(id) {
            const res = await this.getContractMonthByidApi(id);
            if (res) {
                this.formData = res;
                if (!res.PSDOutputInfo) {
                    res.PSDOutputInfo = [];
                }
                this.tableData = res.PSDOutputInfo;
                this.sumRow.purchase_volume = this.formData.month_purchase_volume_total;
                this.sumRow.tax_amount = this.formData.tax_amount_total;
                this.sumRow.amount = this.formData.amount_total;
                this.sumRow.amount_tax = this.formData.amount_tax_total;
                if (this.tableData.length > 0) {
                    this.tableData.push(this.sumRow);
                }
                this.contract_number = this.formData.contract_number;
                this.getSupplySites();
            }
        },
        // 切换场站-重新拉取原材料列表
        async getContractMonthStation() {
            const res = await this.getContractMonthApi();
            if (res) {
                if (!res.PSDOutputInfo) {
                    res.PSDOutputInfo = [];
                }
                this.tableData = res.PSDOutputInfo;
                this.tableData.map(item => {
                    // 采购单价（不含税）=采购单价（含税）/（1+税率%）
                    if (item.unit_price_tax) {
                        if (item.tax_rate) {
                            item.unit_price = (Number(item.unit_price_tax) / (1 + Number(item.tax_rate) / 100)).toFixed(2);
                        } else {
                            item.unit_price = (Number(item.unit_price_tax) / 1).toFixed(2);
                        }
                    }
                });
                this.sumRow.purchase_volume = res.month_purchase_volume_total;
                this.sumRow.tax_amount = res.tax_amount_total;
                this.sumRow.amount = res.amount_total;
                this.sumRow.amount_tax = res.amount_tax_total;
                if (this.tableData.length > 0) {
                    this.tableData.push(this.sumRow);
                }
            }
        },
        // 拉取场站
        async getSupplySites() {
            const res = await this.getSupplySitesApi();
            if (res) {
                this.supplySites = res;
            }
        },
        // 下拉选取场站
        supplySiteChange(value) {
            const data = this.supplySites.filter(item => item.station_name === value);
            this.formData.station_name = data[0].station_name;
            this.formData.station_id = data[0].station_id;
            this.$forceUpdate();
            if (this.formData.station_id && this.formData.supplement_date) {
                this.getContractMonthStation();
            }

        },
        // 选取月份
        choseDate() {
            if (this.formData.station_id && this.formData.supplement_date) {
                this.getContractMonthStation();
            }
        },
        // 删除行
        handleDelete(index, row) {
            this.tableData.splice(index, 1);
        },
        // 新增一行
        addRow() {
            const row = {
                type_name: '',
                child_type_name: '',
                spec_name: '',
                source_name: '',
                purchase_volume: '',
                unit_price: '',
                unit_price_tax: '',
                tax_amount: '',
                tax_rate: '',
                amount: '',
                amount_tax: '',
            };
            if (this.tableData.length > 0) {
                const index = this.tableData.length - 1;
                this.tableData.splice(index, 0, row);
            }
        },
        // 选择原材料
        choseRow(index) {
            this.selectedIndex = index;
            this.$toast({
                title: true,
                text: '选择原材料',
                type: 'eject',
                width: '1200px',
                height: '80%',
                t_url: 'tableList/index',
                viewPosition: 'view',
                extr: {
                    closeBtn: {},
                    code: {
                        TableCode: 'cg_htbl_ycl',
                        QueryString: 'contract_number=' + this.contract_number + '&station_id=' + this.formData.station_id,
                    },
                    sureCallback: this.selectedData,
                },
            });
        },
        selectedData(data) {
            this.tableData.splice(this.selectedIndex, 1);
            data.map(item => {
                const json = {
                    purchase_volume: '',
                    unit_price: '',
                    tax_amount: '',
                    amount: '',
                    amount_tax: '',
                };
                item = { ...item, ...json };
                // 采购单价（不含税）=采购单价（含税）/（1+税率%）
                if (item.unit_price_tax) {
                    if (item.tax_rate) {
                        item.unit_price = (Number(item.unit_price_tax) / (1 + Number(item.tax_rate) / 100)).toFixed(2);
                    } else {
                        item.unit_price = (Number(item.unit_price_tax) / 1).toFixed(2);
                    }
                }
                const index = this.tableData.length - 1;
                this.tableData.splice(index, 0, item);
            });
        },
        addSupplementMonthApi(data) {
            const path = '/interfaceApi/procurement/purchase_supplement/add_supplement_day';
            return this.$axios.$post(path, data, { defEx: true });
        },
        modifySupplementDayApi(data) {
            const path = '/interfaceApi/procurement/purchase_supplement/modify_supplement_day';
            return this.$axios.$put(path, data, { defEx: true });
        },
        getContractMonthByidApi(id) {
            const path = '/interfaceApi/procurement/purchase_supplement/get_supplement_day_by_id?id=' + id;
            return this.$axios.$get(path, { defEx: true });
        },
        getSupplySitesApi() {
            const path = '/interfaceApi/procurement/purchase_supplement/get_station_list?contract_number=' + this.contract_number;
            return this.$axios.$get(path, { defEx: true });
        },
        getContractMonthApi() {

            let path = '/interfaceApi/procurement/purchase_supplement/get_supplement_contract_day?contract_number='
            + this.contract_number;
            if (this.formData.station_id) {
                path += '&station_id=' + this.formData.station_id;
            }
            if (this.formData.supplement_date) {
                path += '&date=' + this.formData.supplement_date;
            }
            return this.$axios.$get(path, { defEx: true });
        },
        // 计算与方量相关
        computedVolume(rowData) {
            // 采购单价（不含税）=采购单价（含税）/（1+税率%）
            if (rowData.unit_price_tax) {
                if (rowData.tax_rate) {
                    rowData.unit_price = (Number(rowData.unit_price_tax) / (1 + Number(rowData.tax_rate) / 100)).toFixed(2);
                } else {
                    rowData.unit_price = (Number(rowData.unit_price_tax) / 1).toFixed(2);
                }
            }
            // 本月采购金额（不含税）=采购单价（不含税）*采购量
            if (rowData.unit_price && rowData.purchase_volume) {
                rowData.amount = (Number(rowData.unit_price) * Number(rowData.purchase_volume)).toFixed(2);
            }
            // 本月采购金额（含税）=采购单价（含税）*采购量
            if (rowData.unit_price_tax && rowData.purchase_volume) {
                rowData.amount_tax = (Number(rowData.unit_price_tax) * Number(rowData.purchase_volume)).toFixed(2);
            }
            // 税额=（采购单价（含税）-采购单价（不含税））*采购量
            if (rowData.unit_price_tax && rowData.unit_price && rowData.purchase_volume) {
                rowData.tax_amount = ((Number(rowData.unit_price_tax) - Number(rowData.unit_price))
                * Number(rowData.purchase_volume)).toFixed(2);
            }
            this.computedSum();
        },
        // 合计
        computedSum() {
            const sumData = {
                type_name: '合计',
                child_type_name: '',
                spec_name: '',
                source_name: '',
                purchase_volume: 0,
                unit_price: '',
                unit_price_tax: '',
                amount: 0,
                tax_amount: 0,
                tax_rate: 0,
                amount_tax: 0,
            };
            this.tableData.map((item, index) => {
                if (index < this.tableData.length - 1) {
                    if (!item.purchase_volume) {
                        item.purchase_volume = 0;
                    }
                    if (!item.amount) {
                        item.amount = 0;
                    }
                    if (!item.amount_tax) {
                        item.amount_tax = 0;
                    }
                    if (!item.tax_amount) {
                        item.tax_amount = 0;
                    }
                    sumData.purchase_volume = (Number(sumData.purchase_volume) + Number(item.purchase_volume)).toFixed(2);
                    sumData.amount = (Number(sumData.amount) + Number(item.amount)).toFixed(2);
                    sumData.amount_tax = (Number(sumData.amount_tax) + Number(item.amount_tax)).toFixed(2);
                    sumData.tax_amount = (Number(sumData.tax_amount) + Number(item.tax_amount)).toFixed(2);
                }
            });
            this.tableData[this.tableData.length - 1] = { ...sumData };
        },
    },
};
</script>
<style lang="stylus">
.monthMakeup
    padding 20px
    height 100%
    overflow hidden
    .table-con
        height calc(100% - 80px)
        .custom-table
            border 1px solid #D7D7D7
            border-spacing 0px
            border-collapse collapse
            width 100%
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button
                -webkit-appearance none !important
            .pump-select
                .el-select
                    width 100px
                    input
                        border 1px solid #DCDFE6 !important
                        height 32px
                        line-height 32px
                    .el-input__icon
                        line-height 32px!important
            th
                text-align left
                font-weight normal
            .el-select
                width 100%
            .text-center
                text-align center
            td,th
                border 1px solid #D7D7D7
                border-collapse collapse
                height 42px
                font-size 16px;
                padding-left 10px
                input
                    width 100%
                    height 100%
                    font-size 16px
                    height 38px
                    line-height 40px
                    border none
                .el-input__inner
                    border none
                .danger
                    span
                        color #E60000
            td
                .el-input__inner
                    padding 0
            .column-tit
                background #f6f8fc
                color #022782
            .table-tit
                background #edf0f5
                text-align center
                font-size 16px
                font-weight bold
                color #022782
        .el-table
            margin-top 10px
            thead
                &.is-group
                    th
                        background #f6f8fc
                        border-right 1px solid #D7D7D7
                        .cell
                            font-size 16px
                            color #022782
                            font-weight normal
            .is-leaf
                border-bottom 1px solid #D7D7D7
            th
                border-right 1px solid #D7D7D7
                border-bottom 1px solid #D7D7D7
                text-align center
            td
                border-right 1px solid #D7D7D7
                border-bottom 1px solid #D7D7D7
                padding 3px
                text-align center
                .el-input__inner
                    padding 0 3px
                    height 32px
                    line-height 32px
                    text-align center
            tr
                &:last-child
                    td
                        background #f5f7fa
                        color #823802
                        &:first-child
                            background #f5f2ed
                            color #823802
            .cell
                padding-left 0
                padding-right 0
                .danger
                    span
                        color #f56c6c
        .el-table--border, .el-table--group
            border 1px solid #D7D7D7
    .btn-con
        text-align center
        position absolute
        width calc(100% - 40px)
        bottom 20px
        button
            width  260px
            height 50px
            font 20px '微软雅黑'
            margin 0 15px
            border none
            cursor pointer
            &.save
                color #fff
                background #1577d2
            &.Close
                color #1577d2
                background #fff
                border 1px solid #1577d2
</style>
